import { render, staticRenderFns } from "./AppTextBtn.vue?vue&type=template&id=4f0e4050&scoped=true&"
import script from "./AppTextBtn.vue?vue&type=script&lang=js&"
export * from "./AppTextBtn.vue?vue&type=script&lang=js&"
import style0 from "./AppTextBtn.vue?vue&type=style&index=0&id=4f0e4050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0e4050",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
